module.exports = __webpack_public_path__ + "static/media/html.d882d855.svg";